module.exports = "/img/4.d2dabd.webp";